export default {
  items: [
    {
      id: 'navigation',
      title: 'v0.0.12',
      type: 'group',
      icon: 'icon-navigation',
      children: [
        {
          id: 'home',
          title: 'Dashboard',
          type: 'item',
          url: '/',
          icon: 'material-symbols:dashboard-outline',
          customIcon: true,
          action: 'DASHBOARD',
          width: '20',
          height: '20'
        },
      ],
    },
    {
      id: 'admin',
      title: 'ADMIN',
      type: 'group',
      children: [
        {
          id: 'equipmentJsonSchema',
          title: 'Equipment Unit JSON Schema',
          type: 'item',
          url: '/equipment-unit/json-schema',
          icon: 'carbon:schematics',
          customIcon: true,
          action: 'EQUIPMENT UNIT JSON SCHEMA',
          width: '20',
          height: '20'
        },
        // {
        //   id: 'sensorJsonSchema',
        //   title: 'Sensor JSON Schema',
        //   type: 'item',
        //   url: '/sensor/json-schema',
        //   icon: 'tabler:schema',
        //   customIcon: true,
        //   action: 'SENSOR JSON SCHEMA',
        //   width: '20',
        //   height: '20'
        // },
        {
          id: 'categoryManagement',
          title: 'Manage Global Categories',
          type: 'item',
          url: '/categories/global',
          icon: 'carbon:wikis',
          customIcon: true,
          action: '',
          width: '20',
          height: '20'
        },
        {
          id: 'sensorListGlobal',
          title: 'View All Sensors',
          type: 'item',
          url: '/sensor/all',
          icon: 'tabler:list',
          customIcon: true,
          action: '',
          width: '20',
          height: '20'
        },
        {
          id: 'logOut',
          title: 'Log out',
          type: 'item',
          url: '/login',
          icon: 'feather:log-out',
          customIcon: true,
          action: 'LOG OUT',
          width: '20',
          height: '20'
        }
      ],
    },
  ],
};
